import { Box, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

import { normalizePhoneNumber } from 'common/utils';

import DefaultContactChip from '../DefaultContactChip';

import PlaceholderEmailMarker from './PlaceholderEmailMarker';

/**
 * One email or phone from usePartnerContactForPatient, shown the way the order page shows it: a dash
 * when there is none, the Default chip when the patient's default stands in, "Not emailed" for a
 * placeholder default email, and a skeleton while the contacts load.
 */
const PartnerContactValue = ({ partnerContact, contactKind }) => {
  if (!partnerContact) {
    return (
      <Skeleton
        variant='text'
        width={140}
        aria-label={`Loading ${contactKind}`}
        sx={{ display: 'inline-block' }}
      />
    );
  }

  const isEmail = contactKind === 'email';
  const value = isEmail ? partnerContact.email : normalizePhoneNumber(partnerContact.phoneNumber);
  const isDefaultShown = isEmail
    ? partnerContact.isDefaultEmailShown
    : partnerContact.isDefaultPhoneShown;

  return (
    <Box
      component='span'
      sx={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', columnGap: 1 }}
    >
      <span>{value || '—'}</span>
      {isDefaultShown && <DefaultContactChip contactKind={contactKind} />}
      {isEmail && value && partnerContact.isPlaceholderEmailShown && <PlaceholderEmailMarker />}
    </Box>
  );
};

PartnerContactValue.propTypes = {
  partnerContact: PropTypes.shape({
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    isDefaultEmailShown: PropTypes.bool,
    isDefaultPhoneShown: PropTypes.bool,
    isPlaceholderEmailShown: PropTypes.bool,
  }),
  contactKind: PropTypes.oneOf(['email', 'phone']).isRequired,
};

PartnerContactValue.defaultProps = {
  partnerContact: undefined,
};

export default PartnerContactValue;
